@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (
    $.row &&
    $.adata.fetch_key &&
    $.row[$.adata.fetch_key] !== '0001-01-01T00:00:00'
  ) {
    <span>{{ $.row[$.adata.fetch_key] | Age }} </span>
  } @else {
    <span>-</span>
  }
}
